import React from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { Text } from '@/shared/ui';
import { Colors } from '@/shared/theme';

const NoticeText = styled(Text)`
  color: ${Colors.hint};
  text-align: center;
  max-width: 520px;
`;

// Google policies.google.com refuses to be framed, so this must be a real
// new-tab anchor rather than the in-app LinkModal/LinkDrawer pattern used
// for our own legal links.
const NoticeLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  color: ${Colors.primary};
  font-weight: 700;
  text-decoration: none;
  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

// Google's Terms of Service require this disclosure wherever the badge
// (.grecaptcha-badge, hidden in src/index.css) is not visibly shown.
export const RecaptchaNotice: React.FC = () => (
  <NoticeText size="p3">
    <Trans
      i18nKey="general.recaptcha-notice"
      components={{
        1: (
          <NoticeLink
            aria-label="Google Privacy Policy"
            href="https://policies.google.com/privacy"
          />
        ),
        2: (
          <NoticeLink
            aria-label="Google Terms of Service"
            href="https://policies.google.com/terms"
          />
        ),
      }}
    />
  </NoticeText>
);
